
        require('./index.scss');
        'use strict';

var $ = window.$;
var mod = $('.module-breadcrumbs');
var _module = {
    init: function init() {
        var span = mod.find('span:last');
        if (span) {
            span.remove();
        }
    }
};
_module.init();;
    


// WEBPACK FOOTER //
// ./src/module/home-detail/breadcrumbs/index.js